export default {
  title: "Clicca o trascina il file in quest'area per caricare",
  description: 'Formati supportati: .csv, .xls, .xlsx',
  buttons: {
    download_template: 'Scarica modello di importazione',
  },
  toasts: {
    error: 'Caricamento file non riuscito',
  },
};
